export const MAX_ATTEMPTS = 3;

export const PAYMENT_METHODS = {
  Card: "stripe_card",
  Bank: "stripe_bank",
};

export const BILLING_FREQUENCY = ["Monthly"];

export const CURRENCY = ["USD", "EUR", "NPR", "AUD", "INR", "MXN", "CAD"];

export const ADJUSTMENT_TYPES = {
  Discount: "d",
  Adjustment: "a",
};

export const ADJUSTMENT_VALUE_TYPES = {
  Amount: "a",
  Percentage: "p",
};

export const INVOICE_STATUS_TYPES = {
  Unpaid: "unpaid",
  Paid: "paid",
  Pending: "pending",
  Fail: "fail",
  Withdrawn: "withdrawn",
  Paused: "paused",
  Queued: "queued",
  Refund: "refund",
  "Alternate Arrangement": "alternate",
};

export const PAYMENT_STATUS_TYPES = {
  Unpaid : "unpaid",
  Paid : "paid",
  Pending : "pending",
  Fail : "fail"
}

export const PAYMENT_TYPES = {
  CHARGE : "charge",
  REFUND : "refund",
}

export const INVOICE_PAYMENT_TYPES = {
  Reoccuring: "reoccuring",
  Onetime: "onetime",
};

export const ACCOUNT_BALANCE_TYPES = {
  FUND: "fund",
  MESSAGE: "message",
};

export const SUBSCRIPTION_STATUS = {
  PAUSE: "PAUSE",
  PAUSEWITHOUTINVOICE: "PAUSEWITHOUTINVOICE",
};

export const PAYMENT_METHOD_TYPES = {
  cash: "Cash",
  cheque: "Cheque",
  stripe_card: "Card",
  stripe_bank: "Bank",
};
